import React from 'react';
import { ReservationDetails } from 'Molecules/';
import { Header, SubFooter } from 'Atoms/';

export default function reservationDetails() {
  return (
    <div>
      <Header
        classType="header-int"
        title1="Waiʻānapanapa"
        title2="State Park"
        url="waianapanapa"
      />
      <ReservationDetails park="61dd69adf4476d02b032ae48" url="waianapanapa" />
      <SubFooter name="Waiʻānapanapa State Park" url="waianapanapa" />
    </div>
  );
}
